import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import CountdownTimer from '../CountdownTimer';

const CALENDLY_URL = 'https://calendly.com/contact-bankkimedia/30min';

const HeroSection = () => {
  const { t } = useTranslation();
  const h = t('home.hero', { returnObjects: true });

  return (
    <section data-testid="hero-section" className="pt-28 pb-16 md:pt-36 md:pb-20">
      <div className="container-custom text-center">
        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#c8ff00]/30 bg-[#c8ff00]/5 mb-8">
          <Clock className="w-4 h-4 text-[#c8ff00]" />
          <span className="text-[#c8ff00] text-sm font-bold uppercase tracking-wider">{h.badge}</span>
        </motion.div>

        <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold font-['Syne'] leading-[1.1] mb-6 max-w-4xl mx-auto">
          {h.h1}<br /><span className="text-[#c8ff00]">{h.h1Accent}</span>
        </motion.h1>

        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="text-white/60 text-lg md:text-xl max-w-2xl mx-auto mb-8 leading-relaxed">
          {h.description}
        </motion.p>

        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.25 }} className="mb-8">
          <p className="text-white/40 text-xs uppercase tracking-wider mb-3">{h.expiresIn}</p>
          <CountdownTimer />
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }} className="flex flex-wrap justify-center gap-4">
          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" data-testid="hero-cta">
            <motion.span whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} className="inline-flex items-center gap-2 px-10 py-4 bg-[#c8ff00] text-black font-bold rounded-full text-lg hover:bg-[#d4ff33] transition-colors">
              {h.ctaPrimary}
              <ArrowRight className="w-5 h-5" />
            </motion.span>
          </a>
          <a href="tel:+13235777420" className="inline-flex items-center gap-2 px-8 py-4 border border-white/20 text-white font-bold rounded-full hover:bg-white/5 transition-all">
            <Phone className="w-4 h-4" />
            {h.ctaCall}
          </a>
        </motion.div>

        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} className="text-white/30 text-sm mt-4">{h.subtext}</motion.p>
      </div>
    </section>
  );
};

export default HeroSection;
